import './notice.css';

export function Notice({ message }: { message?: string }) {
  return (
    <section className="notice">
      <strong className="notice__title">앗!</strong>
      {message ? (
        <p>{message}</p>
      ) : (
        <>
          <p>
            페이지 로딩에 <b>실패</b>했어요😥
          </p>
          <p>잠시후 다시 시도해주세요</p>
        </>
      )}
    </section>
  );
}
